export const sortArrayOfObjects = <T>(
  array: T[],
  fieldName: string,
  desc = true
): T[] =>
  [...array].sort((a, b) => {
    if (!a[fieldName] || !b[fieldName]) {
      return 0
    }
    if (a[fieldName] > b[fieldName]) {
      return desc ? 1 : -1
    }
    if (a[fieldName] < b[fieldName]) {
      return desc ? -1 : 1
    }
    return 0
  })

export const calculatePriority = (
  list: any[],
  oldIndex: number,
  newIndex: number,
  priorityFieldName = 'priority'
): number => {
  const prev = newIndex < oldIndex ? list[newIndex - 1] : list[newIndex]
  const next = newIndex <= oldIndex ? list[newIndex] : list[newIndex + 1]

  const prevPriority = (prev && prev[priorityFieldName]) || 0
  const nextPriority = (next && next[priorityFieldName]) || prevPriority + 1

  return (prevPriority + nextPriority) / 2
}
